import { ModeloBase } from "./modeloBase"


export class ModeloSopSales extends ModeloBase {
  cod_tela_sop_sales?: number // SERIAL PRIMARY KEY
  des_time?: string // Pode ser string se for uma data ou tipo adequado
  cod_dim_region?: number
  cod_dim_product?: number;

  num_sales_real_units?: number;
  num_sales_forecast_units?: number;
  num_sales_budget_units?: number;
  num_sales_real_usd?: number;
  num_sales_forecast_usd?: number;
  num_sales_budget_usd?: number;
  num_forecast_accuracy?: number;
  num_yoy?: number;
  num_selling_price_real?: number;
  num_selling_price_forecast?: number;
  num_selling_price_budget?: number;

  des_business_unit?: string;
  des_region?: string;
  des_product_family?: string;
  des_product?: string;

  cod_product ?: string;
  cod_region ?: string;
  cod_business_unit ?: string;

  num_sales_new?: number;

}
